import type React from 'react';
import QuickReply from '../components/QuickReply';
import type { Button as ButtonType } from '../types/ChatWindow';
import type { MessageScheme } from '../types/configs';

type IProps = {
  buttons: ButtonType[];
  isFromMenu?: boolean | undefined;
  onClick: (...args: any[]) => void;
  scheme: MessageScheme;
};

const QuickReplyList: React.FC<IProps> = ({
  buttons,
  isFromMenu,
  onClick,
  scheme,
}) => {
  return (
    <div className={`message-buttons ${isFromMenu ? 'from-menu' : ''}`}>
      {buttons.map((button) => {
        return (
          <QuickReply
            key={button.payload}
            button={button}
            onClick={onClick}
            scheme={scheme}
          />
        );
      })}
    </div>
  );
};

export default QuickReplyList;
